import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Avatar, Menu, MenuItem, IconButton } from "@mui/material";

interface AvatarMenuProps {
  isAuthenticated: boolean;
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSignOutClick = () => {
    setAnchorEl(null);
    navigate("/auth/signout");
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      <IconButton
        onClick={handleUserMenuClick}
        size="small"
        sx={{ ml: 1 }}
        aria-controls={open ? "user-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <Avatar sx={{ width: 32, height: 32, bgcolor: "secondary.main" }}>
          U
        </Avatar>
      </IconButton>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleUserMenuClose}
        onClick={handleUserMenuClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          component={Link}
          to="/settings"
          onClick={handleUserMenuClose}
          sx={{ textDecoration: "none", color: "inherit" }}
        >
          {t("navbar.settings")}
        </MenuItem>
        <MenuItem onClick={handleSignOutClick}>{t("navbar.signOut")}</MenuItem>
      </Menu>
    </>
  );
};

export default AvatarMenu;
